// extracted by mini-css-extract-plugin
module.exports = {"label":"IDPButton_label__uThd6","item":"IDPButton_item__5HExV"};